import { AxiosError, AxiosInstance } from 'axios';
import createAuthRefreshInterceptor from 'axios-auth-refresh';

import { refreshTokenWithLock } from './auth';
import { requestErrorInterceptor, requestInterceptor } from './request';
import { responseErrorInterceptor, responseInterceptor } from './response';

export const setupBaseInterceptors = (instance: AxiosInstance): void => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  instance.interceptors.request.use(requestInterceptor, requestErrorInterceptor);

  instance.interceptors.response.use(responseInterceptor, responseErrorInterceptor);
};

const setupAuthInterceptors = (instance: AxiosInstance) => {
  const refreshAndSetToken = async (failedRequest: AxiosError) => {
    const access = await refreshTokenWithLock(instance?.defaults?.baseURL);
    if (failedRequest.response?.config.headers) {
      failedRequest.response.config.headers.Authorization = `Bearer ${access}`;
    }
    instance.defaults.headers.common.Authorization = `Bearer ${access}`;
  };

  createAuthRefreshInterceptor(instance, refreshAndSetToken, {
    statusCodes: [401],
  });
};

export function setupInterceptors(instance: AxiosInstance): void {
  setupBaseInterceptors(instance);
  setupAuthInterceptors(instance);
}
